import type { HttpTypes } from '@medusajs/types';

/**
 * Check if a product variant is marked as "cash only" (not eligible for reward points).
 * @param variant - Product variant to check
 * @returns True if the variant is cash only
 */
export const isCashOnlyProductVariant = (
  variant: Pick<HttpTypes.StoreProductVariant, 'metadata'> | null = null
): boolean => {
  if (variant === null) return false;
  if (!variant.metadata) return false;
  return variant.metadata.cash_only === true;
};
